__turbopack_context__.v({
  "Sitemap": "cirjcq_Sitemap",
  "col": "cirjcq_col",
  "containerLogos": "cirjcq_containerLogos",
  "dFlex": "cirjcq_dFlex",
  "itemLogos": "cirjcq_itemLogos",
  "navFooter": "cirjcq_navFooter",
});
